// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Forward10IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Forward10Icon" ref={forwardedRef} {...props}>
      <path d="M15.5 8.27h-5v-1.5h2.458a5 5 0 0 0-3.452-1.378 5.003 5.003 0 0 0-5.006 5 5 5 0 0 0 3.648 4.814v1.544A6.504 6.504 0 0 1 3 10.392c0-3.59 2.913-6.5 6.506-6.5A6.5 6.5 0 0 1 14 5.692V3.27h1.5z" />
      <path d="M15.57 16.894c-1.311 0-2.127-1.016-2.127-2.664v-.568c0-1.648.816-2.656 2.128-2.656 1.32 0 2.144 1.008 2.144 2.656v.568c0 1.648-.824 2.664-2.144 2.664m-.935-2.56a3 3 0 0 0 .032.472l1.56-2.384a.78.78 0 0 0-.656-.344c-.584 0-.936.544-.936 1.48zm.288 1.152a.78.78 0 0 0 .648.336c.608 0 .96-.552.952-1.488l-.008-.776a4 4 0 0 0-.032-.456z" />
      <path d="M9.324 15.678v1.072h3.224v-1.072h-.976V11.15H10.7l-1.616.928.32.728.976-.296v3.168z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Forward10Icon = /* @__PURE__ */ Object.assign(
  Forward10IconComponent,
  { displayName: 'Forward10Icon' },
);
